import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.video-slider__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          arrows: true,
          gap: '2rem',
          perPage: 2,
          heightRatio: 0.33,
          paginationKeyboard: true,
          drag: true,
          pagination: false,
          start: 1,
          breakpoints: {
            768: {
              perPage: 1,
              heightRatio: 0.62,
            },
          },
        } );
        slider.mount( );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'video-slider', COMPONENT );
} )( app );
